export default __webpack_public_path__ + "static/media/hide-password.fbde5b0b.svg";